import axiosInstance from "../axios";

const PREFIX = "/Notification";

export const CreateUserQuestionMessage = (body) => {
  return axiosInstance.post(`${PREFIX}/CreateUserQuestionMessage`, {
    ...body,
  });
};
